import * as React from 'react';
import Service from '../../../util/Service';
import { prettify, useInterval } from '../../../util/Utilitarios';
import { Box } from '@mui/material';


export default function BGErroDebugPanel(props){
    const {processoBG, update} = props;
    const [debug, setDebug] = React.useState(false);
    const [pdebug, setPdebug]= React.useState();
    
    React.useEffect(()=>{
        if( processoBG ){
            setDebug(processoBG.onDebug);
        }
    },[processoBG])
    React.useEffect(()=>{
        if( debug ){
            buscaBGDebug()
        }else{
            setPdebug();
        }
    },[debug]);

    function buscaBGDebug(){
        if( !pdebug){
            Service.GET("/api/security/backGroundTask/debugById/"+processoBG.id).then( r=>setPdebug(r));
        }else{
            const dtUpdate = pdebug.dtUpdate;
            Service.GET("/api/security/backGroundTask/debugById/"+processoBG.id).then( r=>{
                setPdebug(r);
                if( dtUpdate !== r.dtUpdate){
                    update(r);
                }
            });
        }
    }
    
    useInterval(5000, ()=>{
        if( processoBG && processoBG.onDebug){
            buscaBGDebug();
        }
    })
    if(!pdebug)return
    return (
        <Box sx={{
            // border: "1px solid var(--pd-primary-dark)",
            // borderRadius: '5px', width:'100%',
            p:2,
        }}>
            <pre style={{
                background: 'black',
                color: '#fff',
                whiteSpace: "pre-wrap",
                textWrap: "pretty"
            }}>
            {prettify(pdebug.linhas)}
            </pre>
        </Box>
    )
}